import { ILossPreventionConfig } from '../useLossPreventionConfig'

export const burgerworksConfig: ILossPreventionConfig = {
  summary: {
    isVisible: true,
  },
  kpiSettings: [
    { category: 'basic', key: 'totalComps', title: 'Total Discounts' },
    {
      category: 'custom',
      type: 'Deletes',
      title: 'Deletes',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Voids',
      title: 'Voids',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Overrings',
      title: 'Overrings',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Refunds',
      title: 'Refunds',
      key: 'amount',
    },
  ],
  cashHandlingTable: {
    display: true,
    columns: [
      {
        key: 'cashOverOrShort.amount',
        title: 'Cash +/-',
        valueType: 'price',
        width: '150px',
      },
      {
        key: 'Over Ring',
        title: 'Over Ring',
        children: [
          {
            key: 'Over Ring.count',
            title: '#',
            valueType: 'count',
            width: '75px',
            sorter: true,
          },
          {
            key: 'Over Ring.amount',
            title: '$',
            valueType: 'price',
            width: '75px',
            sorter: true,
          },
        ],
      },
      {
        key: 'Deal after Total',
        title: 'Deletes',
        children: [
          {
            key: 'Deal after Total.count',
            title: '#',
            valueType: 'count',
            width: '75px',
            sorter: true,
          },
          {
            key: 'Deal after Total.amount',
            title: '$',
            valueType: 'price',
            width: '75px',
            sorter: true,
          },
        ],
      },
      {
        key: 'cashOverOrShort.checkPercent',
        title: '% Shifts with Inaccurate Cash',
        valueType: 'percent',
        width: '150px',
        sorter: true,
      },
      {
        key: 'Over Ring.checkPercent',
        title: '% Checks with Over Ring',
        valueType: 'percent',
        width: '150px',
        sorter: true,
      },
      {
        key: 'Deal after Total.checkPercent',
        title: '% Checks with Deletes',
        valueType: 'percent',
        width: '150px',
        sorter: true,
      },
    ],
  },
  voidsAndDeletesTable: {
    display: false,
    columns: [],
  },
  discountByEmployeeTable: {
    display: true,
  },
  opsCompsBreakdownTable: {
    display: true,
  },
}
